export class IdpGroupUser {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "givenName",
            "baseName": "givenName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IdpGroupUser.attributeTypeMap;
    }
    constructor() {
    }
}
